import api from './api';

export const getNotificacoes = async () => {
  try {
    console.log('Buscando notificações...');
    const response = await api.get('/notificacoes');
    console.log('Resposta:', response.data);
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar notificações:', error);
    throw error;
  }
};

export const getNaoLidas = async () => {
  try {
    const response = await api.get('/notificacoes/nao-lidas');
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar notificações não lidas:', error);
    throw error;
  }
};

export const marcarNotificacaoComoLida = async (notificacaoId) => {
  try {
    const response = await api.patch(`/notificacoes/${notificacaoId}/lida`);
    return response.data;
  } catch (error) {
    console.error('Erro ao marcar notificação como lida:', error);
    throw error;
  }
};

export const marcarTodasComoLidas = async () => {
  try {
    const response = await api.patch('/notificacoes/marcar-todas-lidas');
    return response.data;
  } catch (error) {
    console.error('Erro ao marcar todas notificações como lidas:', error);
    throw error;
  }
};

export const deleteNotificacao = async (notificacaoId) => {
  try {
    const response = await api.delete(`/notificacoes/${notificacaoId}`);
    return response.data;
  } catch (error) {
    console.error('Erro ao deletar notificação:', error);
    throw error;
  }
};

export const criarNotificacao = async (dados) => {
  try {
    const response = await api.post('/notificacoes', dados);
    return response.data;
  } catch (error) {
    console.error('Erro ao criar notificação:', error);
    throw error;
  }
};

export const getNotificacoesPorTipo = async (tipo) => {
  try {
    const response = await api.get(`/notificacoes/tipo/${tipo}`);
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar notificações por tipo:', error);
    throw error;
  }
};

// Novos métodos para notificações de campanhas
export const criarNotificacaoCampanha = async ({
  nomeCampanha,
  nomeInstituicao,
  campanhaId,
  usuariosIds
}) => {
  try {
    const notificacoesBatch = usuariosIds.map(usuarioId => ({
      usuarioId,
      titulo: `Nova Campanha: ${nomeCampanha}`,
      mensagem: `A instituição ${nomeInstituicao} acabou de lançar uma nova campanha: ${nomeCampanha}. Confira as oportunidades disponíveis!`,
      link: `/campanhas/${campanhaId}`,
      lida: false
    }));

    const response = await api.post('/notificacoes/campanha/batch', {
      notificacoes: notificacoesBatch
    });

    return response.data;
  } catch (error) {
    console.error('Erro ao criar notificações de campanha:', error);
    throw error;
  }
};

export const getEstudantesAtivos = async () => {
  try {
    console.log('Buscando estudantes ativos...');
    const response = await api.get('/dashboard/estudantes-ativos');
    console.log('Estudantes ativos encontrados:', response.data);
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar estudantes ativos:', error);
    throw error;
  }
};

export const criarNotificacaoCampanhaParaEstudantes = async ({
  nomeCampanha,
  nomeInstituicao,
  campanhaId
}) => {
  try {
    // Primeiro busca todos os estudantes ativos
    const estudantes = await getEstudantesAtivos();
    
    if (estudantes && estudantes.length > 0) {
      console.log(`Criando notificações para ${estudantes.length} estudantes`);
      const notificacoes = estudantes.map(estudante => ({
        usuarioId: estudante.id,
        titulo: `Nova Campanha: ${nomeCampanha}`,
        mensagem: `A instituição ${nomeInstituicao} acabou de lançar uma nova campanha: ${nomeCampanha}. Confira as oportunidades disponíveis!`,
        link: `/campanhas/${campanhaId}`
      }));

      // Criar notificações em lote
      const response = await api.post('/notificacoes/campanha/batch', {
        notificacoes
      });
      
      console.log('Notificações criadas com sucesso:', response.data);
      return response.data;
    }
    
    console.log('Nenhum estudante ativo encontrado');
    return { message: 'Nenhum estudante ativo encontrado', notificacoesCriadas: 0 };
  } catch (error) {
    console.error('Erro ao criar notificações de campanha:', error);
    throw error;
  }
};